import React from 'react';

import HowBrandWorksSection from '@rover/react-lib/src/components/HowBrandWorksSection';
import { PetType } from '@rover/types/src/Pet';

import { PageSectionId, useSectionRef } from '../hooks/useSectionRef';

interface SeoHowBrandWorksProps {
  serviceTypeName?: string;
  providerNounPlural?: string;
  petType?: PetType;
}

const SeoHowBrandWorks = ({
  serviceTypeName,
  providerNounPlural,
  petType,
}: SeoHowBrandWorksProps): JSX.Element => {
  const sectionRef = useSectionRef(PageSectionId.HowBrandWorks);

  return (
    <HowBrandWorksSection
      serviceTypeName={serviceTypeName}
      providerNounPlural={providerNounPlural}
      petType={petType}
      htmlRef={sectionRef}
      headingVariant="heading"
    />
  );
};

export default SeoHowBrandWorks;
